import { IState } from 'legacy/lut/store'

export const selectCommitmentState = (state: IState) => state.partner360.commitment
